var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 201,
    viewBox: "0 0 21 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9854,
    width: 78,
    height: 0.970588,
    transform: "rotate(90 10.9854 0)",
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81317 105.626C4.89851 105.626 4.10051 105.421 3.41917 105.01C2.74717 104.59 2.22451 104.002 1.85117 103.246C1.48717 102.49 1.30517 101.594 1.30517 100.558C1.30517 99.522 1.48717 98.626 1.85117 97.87C2.21517 97.114 2.73317 96.5307 3.40517 96.12C4.08651 95.7093 4.88917 95.504 5.81317 95.504C6.74651 95.504 7.54917 95.7093 8.22117 96.12C8.90251 96.5307 9.42517 97.114 9.78917 97.87C10.1625 98.6167 10.3492 99.508 10.3492 100.544C10.3492 101.58 10.1625 102.481 9.78917 103.246C9.41584 104.002 8.88851 104.59 8.20717 105.01C7.53517 105.421 6.73717 105.626 5.81317 105.626ZM5.81317 104.604C6.86784 104.604 7.68451 104.249 8.26317 103.54C8.84184 102.831 9.13117 101.837 9.13117 100.558C9.13117 99.2793 8.84184 98.29 8.26317 97.59C7.68451 96.8807 6.86784 96.526 5.81317 96.526C4.77717 96.526 3.96984 96.8807 3.39117 97.59C2.81251 98.29 2.52317 99.2793 2.52317 100.558C2.52317 101.827 2.81251 102.821 3.39117 103.54C3.96984 104.249 4.77717 104.604 5.81317 104.604ZM12.4016 105.5V95.63H16.3076C17.3716 95.63 18.1836 95.8773 18.7436 96.372C19.3129 96.8667 19.5976 97.5713 19.5976 98.486C19.5976 99.214 19.3969 99.8113 18.9956 100.278C18.6036 100.745 18.0436 101.048 17.3156 101.188C17.7449 101.337 18.1136 101.701 18.4216 102.28L20.1576 105.5H18.8976L17.1896 102.336C16.9749 101.944 16.7276 101.678 16.4476 101.538C16.1676 101.398 15.7989 101.328 15.3416 101.328H13.5496V105.5H12.4016ZM13.5496 100.418H16.1396C17.6889 100.418 18.4636 99.774 18.4636 98.486C18.4636 97.2167 17.6889 96.582 16.1396 96.582H13.5496V100.418Z",
    fill: "#6D6D6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9854,
    y: 123,
    width: 78,
    height: 0.970588,
    transform: "rotate(90 10.9854 123)",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrImage);
export default __webpack_public_path__ + "static/media/or-image.5b14b752e06a0e171e494c5bd54dee6d.svg";
export { ForwardRef as ReactComponent };